import { API_BASE } from '../utils/apiBase';

class GeocodingAPI {
    // Unauthenticated — used on the anonymous public form-fill page, same as
    // FormsAPI.getPublicForm/FormSubmissionsAPI.submitForm.
    async search(query) {
        try {
            const response = await fetch(`${API_BASE}/geocode/search?q=${encodeURIComponent(query)}`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            });
            if (!response.ok) throw new Error('Failed to search address');
            return await response.json();
        } catch (error) {
            console.error('Error searching address:', error);
            throw error;
        }
    }
}

export default new GeocodingAPI();
